import { Component } from 'react';
import PreviewRow from 'crm_components/dialog/propertyListEditor/PreviewRow';
import PropTypes from 'prop-types';
import { COLUMN_SETTINGS, FAVORITE_PROPERTIES, CREATOR_PROPERTIES, DEAL_STAGE_PROPERTIES, TICKET_STAGE_PROPERTIES } from 'customer-data-objects/property/PropertyListTypes';
import { Small } from 'foundations-components/transitional/components/Small';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import pick from 'transmute/pick';
import merge from 'transmute/merge';
import * as ObjectTypes from 'customer-data-objects/constants/ObjectTypes';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getPassedProps = pick(['type', 'use', 'value', 'onRequiredChange', 'onAddOption', 'onSave', 'onReorderOption', 'onRemoveOption', 'onReset', 'requirable']);
const initialCreatorPropertiesToCheck = {
  [ObjectTypes.COMPANY]: ['domain', 'name'],
  [ObjectTypes.CONTACT]: ['email', 'firstname', 'lastname'],
  [ObjectTypes.DEAL]: [],
  [ObjectTypes.TICKET]: []
};
class PreviewColumn extends Component {
  constructor(...args) {
    super(...args);
    this.shouldRenderDescription = properties => {
      const {
        type
      } = this.props;
      return (
        // @ts-expect-error ts-migrate(2538) FIXME: Type 'undefined' cannot be used as an index type.
        initialCreatorPropertiesToCheck[type].length && !properties.find(property =>
        // @ts-expect-error ts-migrate(2538) FIXME: Type 'undefined' cannot be used as an index type.
        initialCreatorPropertiesToCheck[type].includes(property.value) && property.required === true)
      );
    };
    this.renderInitialCreatorPropertiesDescription = properties => {
      const {
        type
      } = this.props;
      if (!this.shouldRenderDescription(properties)) {
        return null;
      }
      return /*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: `crm_components.PropertyListEditor.defaultRequiredProperties.${type}`
        })
      });
    };
    this.renderInitialCreatorPropertiesSection = () => {
      const {
        initialCreatorProperties
      } = this.props;
      const passedProps = getPassedProps(this.props);
      return /*#__PURE__*/_jsxs(View, {
        as: "div",
        paddingBlockEnd: "200",
        marginBlockEnd: "500",
        borderBlockEndWidth: "100",
        borderBlockEndColor: "border-core-default",
        borderBlockEndStyle: "solid",
        children: [initialCreatorProperties.map((row, index) => {
          const itemProps = merge(passedProps, {
            index,
            value: row
          });
          // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
          return /*#__PURE__*/_jsx(PreviewRow, Object.assign({}, itemProps), row.value);
        }), this.renderInitialCreatorPropertiesDescription(initialCreatorProperties)]
      });
    };
  }
  render() {
    const {
      initialCreatorProperties,
      requirableMessage
    } = this.props;
    const passedProps = getPassedProps(this.props);
    let initialCreatorPropertiesSection = null;
    if (this.props.use === CREATOR_PROPERTIES && initialCreatorProperties.length) {
      initialCreatorPropertiesSection = this.renderInitialCreatorPropertiesSection();
    }
    return /*#__PURE__*/_jsxs(View, {
      paddingInlineEnd: "300",
      as: "div",
      children: [initialCreatorPropertiesSection, requirableMessage, this.props.rows.map((row, index) => {
        index = index + initialCreatorProperties.length;
        const itemProps = merge(passedProps, {
          index,
          value: row
        });
        // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
        return /*#__PURE__*/_jsx(PreviewRow, Object.assign({}, itemProps), row.value);
      })]
    });
  }
}
PreviewColumn.displayName = 'PreviewColumn';
PreviewColumn.propTypes = {
  initialCreatorProperties: PropTypes.arrayOf(PropTypes.object.isRequired),
  rows: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  onAddOption: PropTypes.func.isRequired,
  onRemoveOption: PropTypes.func.isRequired,
  onReorderOption: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  requirable: PropTypes.bool.isRequired,
  requirableMessage: PropTypes.node,
  type: PropTypes.string,
  use: PropTypes.oneOf([COLUMN_SETTINGS, FAVORITE_PROPERTIES, CREATOR_PROPERTIES, DEAL_STAGE_PROPERTIES, TICKET_STAGE_PROPERTIES]).isRequired
};
PreviewColumn.defaultProps = {
  initialCreatorProperties: []
};
export default PreviewColumn;